
import { URL } from '../../config'
import { getRequest  } from '../../utils/functions/httpRequest'

const  eventURL = URL.postevent

const formname = 'orphanedevent'

const FETCH_ORPHANED_EVENTS = `${formname}/FETCH_ORPHANED_EVENTS`
const FETCHING_EVENTS = `${formname}/FETCHING_EVENTS`

export default {
	FETCH_ORPHANED_EVENTS
}

export function fetchOrphanedEvents() 
{    
    return (dispatch,getState) =>
	{
		const userToken = getState().oidc.user.access_token
		const url = `${eventURL}/orphanedevents`
		getRequest(url,'json',userToken).then(resp => {
			dispatch(fetchOrphanedEventSuccess(resp))
		})
	}	
}

export function fetchOrphanedEventSuccess(event) {
	return {
		type: FETCH_ORPHANED_EVENTS,
		payload:event
	}
}

export function requestingEvents() 
{
    return {
        type: FETCHING_EVENTS,
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/action_orphanedevent.js